export const EVENT_TYPES = {
  SETUP_DAILY_LIST: 'SETUP_DAILY_LIST',
} as const;

export type EventType = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES];

type Callback = () => void;

const listeners: { [K in EventType]?: Callback[] } = {};

export const EventBus = {
  subscribe(event: EventType, cb: Callback) {
    (listeners[event] ??= []).push(cb);

    return () => {
      listeners[event] = listeners[event]!.filter((fn) => fn !== cb);
    };
  },

  publish(event: EventType) {
    listeners[event]?.forEach((cb) => cb());
  },
};
